module.exports = __webpack_public_path__ + "img/standard-lead-item-2.4d0bb2a8.png";